export interface IRepairOrderJob {
  branchCode: string;
  repairOrderNumber: number;
  jobCode: string;
  jobType: string;
  detailLine: string;
  isInvoiced: boolean;
  isAdhoc: boolean;
  schedules: ISchedules[];
}

export interface ISchedules {
  techCode: string;
}

export interface IJobDetail {
  cappedPriceService: ICappedPriceService;
  classification?: string;
  code: string;
  description: string;
  estimatedLabourHours?: number;
  externalCode: null;
  price: IPrice;
  type: JobDetailType;
  isInvoiced: boolean;
}

export interface ICappedPriceService {
  indicator: boolean;
  value: number | null;
}

export interface IPrice {
  labour: number | null;
  other: number | null;
  part: null;
  sublet: null;
  total: number | null;
}

export enum JobDetailType {
  E = 'excess',
  F = 'fleet',
  I = 'internal',
  P = 'policy',
  B = 'project billing',
  R = 'retail',
  S = 'sundry',
  W = 'warranty',
}
